import { render, staticRenderFns } from "./SignUpStepFour.vue?vue&type=template&id=10ce3678"
import script from "./SignUpStepFour.vue?vue&type=script&lang=js"
export * from "./SignUpStepFour.vue?vue&type=script&lang=js"
import style0 from "./SignUpStepFour.vue?vue&type=style&index=0&id=10ce3678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports